import section4 from "./bestuhlungsplan-allgemein-01.jpg";
import section7 from "./bestuhlungsplan-allgemein-02.webp";
import section6 from "./bestuhlungsplan-allgemein-03.jpg";
import section2 from "./bestuhlungsplan-allgemein-04.jpg";
import section5 from "./bestuhlungsplan-allgemein-05.jpg";
import section3 from "./bestuhlungsplan-allgemein-06.jpg";
import section1 from "./bestuhlungsplan-allgemein-09.jpg";
import header from "./bestuhlungsplan-allgemein-10.jpg";
import section8 from "./bestuhlungsplan-allgemein-12.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
};
